import { configureStore } from "@reduxjs/toolkit";
import settingsSlice from "./slices/settingsSlice";
import mngrSlice from "./slices/mngrSlice";
import dataSlice from "./slices/dataSlice";
import userSlice from "./slices/userSlice";

export const store = configureStore({
  reducer: {
    setting: settingsSlice,
    mngr: mngrSlice,
    data: dataSlice,
    user: userSlice,
  },
});
